import React, { useState, useEffect, useRef } from "react";
import { ContentCardAndFilters } from "./AdminCoachesContainer.styled";
import { GET_COACHES } from "../../GraphQL/Queries";
import { UPDATE_STATUS_COACH, DELETE_COACH } from "../../GraphQL/Mutations";
import { useMutation, useLazyQuery } from "@apollo/client";
import { useHistory } from "react-router-dom";
import { NotificationManager } from "react-notifications";
import { clientWellness } from "../../App";
import ModalConfirmAction from "../../components/ModalConfirmAction/ModalConfirmAction";
import Paper from "@material-ui/core/Paper";
import { AntTab, AntTabs } from "../../helpers/antTabs";
import AdminCoachesComponent from "../../components/AdminCoachesComponent/AdminCoachesComponent";
import { ReactComponent as EngagementIcon } from "../../assets/svg/engagement-header-icon.svg";
import HeaderComponent from "../../components/Header/Header";
import PortalModal from "../../Portals/PortalModal";
import CategoriesForm from "../../components/CategoriesCreationForm/CategoriesForm";
import {
  CardsWrapper,
  TableViewButton,
  SearchField,
} from "../AdminPage/AdminPage.styled";
import ViewList from "@material-ui/icons/ViewList";
import ViewCards from "@material-ui/icons/ViewModule";
import SearchIcon from "@material-ui/icons/Search";
import { Clear } from "@material-ui/icons";
import { theme as themeConfig } from "../../themes/themes";
import { Tooltip } from "@material-ui/core";
import { Form } from "react-bootstrap";
import Card from "../../components/ConfigurationCards/Card";
import ThemeCategories from "../../components/ThemeCategories/ThemeCategories";

const AdminCoachesContainer = () => {
  const history = useHistory();
  const [selectedMenu, selectMenu] = useState([
    "coachesmanagement",
    "Coaches Management",
  ]);
  const [valueTabs, setValueTabs] = useState(0);
  const [dataFilter, setDataFilter] = useState({});
  const [filtered, setFiltered] = useState(false);
  const [coachesList, setcoachesList] = useState([]);
  const [dataPaginated, setDataPaginated] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorSelected, setAnchorSelected] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(null);
  const [reloadRender, setreloadRender] = useState(false);
  const [showLoader, setshowLoader] = useState(false);
  const [showCards, setShowCards] = useState(true);
  const rowsPerPageList = [5, 10, 20];
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [formTrigger, setFormTrigger] = useState("");
  const [updateData, setupdateData] = useState({});
  const [searchTxt, setSearchTxt] = useState("");
  const rSearch = useRef("");
  const filtersViews = {
    countries: true,
    cities: true,
    search: {
      show: false,
      label: "Search(Name - Last Name)",
    },
  };
  const [updateStatus] = useMutation(UPDATE_STATUS_COACH, {
    client: clientWellness,
  });
  const [deleteCoach] = useMutation(DELETE_COACH, {
    client: clientWellness,
  });
  const [runGetCoaches, { loading: loadingGetCoaches }] = useLazyQuery(
    GET_COACHES,
    {
      client: clientWellness,
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        const allCoachList = data.wellnessCoachesAdmin.map((element) => {
          let dto = {
            idCoach: element.idCoach,
            userId: element.userId,
            cFirstName: element.cFirstName,
            cLastName: element.cLastName,
            agentsAssigned: element.agentsAssigned,
            cEmail: element.cMailBox,
            cCountryName: element.cCountryName,
            cCityName: element.cCityName,
            coachState: element.coachState,
          };
          return dto;
        });
        const allCoachListSorted = allCoachList.sort(
          (a, b) => b.idCoach - a.idCoach
        );
        setcoachesList(allCoachListSorted);
      },
    }
  );

  useEffect(() => {
    let startIndex = rowsPerPage * currentPage;
    setDataPaginated(coachesList.slice(startIndex, startIndex + rowsPerPage));
  }, [rowsPerPage, coachesList, currentPage]);

  useEffect(() => {
    runGetCoaches({
      variables: {
        input: {
          cityId: null,
          countryId: null,
          searchBy: null,
        },
      },
    });
  }, [reloadRender]);

  useEffect(() => {
    if (!filtered) {
      runGetCoaches({
        variables: {
          input: {
            cityId: null,
            countryId: null,
            searchBy: null,
          },
        },
      });
    }
  }, [filtered]);
  let FilterEvents = (searchText) => {
    setFiltered(true);
    runGetCoaches({
      variables: {
        input: {
          cityId: dataFilter.city ? dataFilter.city : null,
          countryId: dataFilter.country ? dataFilter.country : null,
          searchBy: searchText ? searchText : null,
        },
      },
    });
  };

  let updateState = (rowData, state) => {
    setshowLoader(true);
    updateStatus({
      variables: {
        coachId: rowData.idCoach,
        status: state.toUpperCase(),
      },
    })
      .then((response) => {
        setshowLoader(false);
        if (response.data.updateCoachStatus.idCoach > 0) {
          rowData.coachState = state;
          NotificationManager.success("Coach updated successfully", "", 5000);
          setreloadRender(!reloadRender);
        } else {
          NotificationManager.warning("Error to update coach", "", 5000);
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
        setshowLoader(false);
      });
  };

  let toggleChecked = (rowData) => {
    updateState(
      rowData,
      rowData.coachState.toUpperCase() === "ACTIVE" ? "Inactive" : "Active"
    );
  };

  let handleClickActions = (event, rowData) => {
    setAnchorEl(event.currentTarget);
    setAnchorSelected(rowData.idCoach);
  };

  let handleCloseActions = () => {
    setAnchorEl(null);
    setAnchorSelected(null);
  };

  let deleteSurvey = (rowData) => {
    setshowLoader(true);
    deleteCoach({
      variables: {
        coachId: rowData.idCoach,
      },
    })
      .then((response) => {
        setshowLoader(false);
        if (response.data.deleteCoach.idCoach > 0) {
          coachesList.splice(
            coachesList.findIndex((f) => f.idCoach === rowData.idCoach),
            1
          );
          NotificationManager.success("Coach deleted successfully", "", 5000);
          setreloadRender(!reloadRender);
        } else {
          NotificationManager.warning("Error to delete coach", "", 5000);
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
        setshowLoader(false);
      });
    setOpenDeleteModal(null);
  };

  const handleEditEvent = (item) => {
    history.push({
      pathname: `/CreateCoach`,
      state: { action: "edit", coachId: item.idCoach },
    });
  };

  let goToCoachesManagement = () => {
    selectMenu(["coachesmanagement", "Coaches Management"]);
  };

  const goToReasonCategory = () => {
    selectMenu(["reasoncategory", "Reason Category"]);
  };

  let goToCreateCoach = () => {
    history.push({
      pathname: `/CreateCoach`,
      state: { action: "add" },
    });
  };

  const showDeleteModal = () => {
    return openDeleteModal ? (
      <ModalConfirmAction
        title={"Are you sure you want to delete this coach?"}
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        fn={deleteSurvey}
      />
    ) : null;
  };

  const showSelectedMenu = () => {
    return (
      <Card
        activeicon={true}
        icon="plus"
        iconplusactive={false}
        coloricon="#FFFFFF"
        colorBorder="#FFFFFF"
        code="theme"
        title="Theme Category"
        subtitle="Category Administration"
        footerText="New theme category"
        setFormTrigger={setFormTrigger}
      />
    );
  };

  const showCategoryForm = () => {
    return (
      <PortalModal>
        <CategoriesForm
          setupdateData={setupdateData}
          updateData={updateData}
          formTrigger={formTrigger}
          title="New Theme Category"
          setFormTrigger={setFormTrigger}
        />
      </PortalModal>
    );
  };
  let showSelectedTab = (selected) => {
    if (selected === "coachesmanagement") {
      return (
        <AdminCoachesComponent
          goToCreateCoach={goToCreateCoach}
          filtersViews={filtersViews}
          FilterEvents={FilterEvents}
          setDataFilter={setDataFilter}
          filtered={filtered}
          setFiltered={setFiltered}
          showCards={showCards}
          setShowCards={setShowCards}
          loadingGetCoaches={loadingGetCoaches}
          showLoader={showLoader}
          toggleChecked={toggleChecked}
          handleClickActions={handleClickActions}
          anchorSelected={anchorSelected}
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
          setAnchorSelected={setAnchorSelected}
          handleEditEvent={handleEditEvent}
          handleCloseActions={handleCloseActions}
          setOpenDeleteModal={setOpenDeleteModal}
          coachesList={coachesList}
          dataPaginated={dataPaginated}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          rowsPerPage={rowsPerPage}
          rowsPerPageList={rowsPerPageList}
          setRowsPerPage={setRowsPerPage}
        />
      );
    } else if (selected === "reasoncategory") {
      return (
        <ThemeCategories
          formTrigger={formTrigger}
          setFormTrigger={setFormTrigger}
          setupdateData={setupdateData}
          showCards={showCards}
          searchBy={searchTxt}
          setShowCards={setShowCards}
        />
      );
    }
  };

  const handleSearch = (e) => {
    setSearchTxt(e.target.value);
  };

  const handleTabChange = (event, newValue) => {
    if (newValue === 0) goToCoachesManagement();
    if (newValue === 1) goToReasonCategory();
    setValueTabs(newValue);
  };

  return (
    <ContentCardAndFilters>
      <HeaderComponent Icon={EngagementIcon} text={"My Coaches"} />
      <Paper position="static">
        <AntTabs
          aria-label="Coaches Management"
          value={valueTabs}
          onChange={handleTabChange}
        >
          <AntTab label="Coaches Management" />
          <AntTab label="Theme Category" />
        </AntTabs>
      </Paper>
      <CardsWrapper className="pt-3 pb-2" valueTabs={valueTabs}>
        {valueTabs === 1 && showSelectedMenu()}
        {valueTabs === 1 && (
          <div className="right-section">
            <SearchField>
              <SearchIcon style={{ color: themeConfig.text.primary }} />
              <Form.Control
                type="text"
                placeholder="Search"
                onChange={handleSearch}
                ref={rSearch}
              />
              <Clear
                style={{
                  right: "0",
                  color: themeConfig.neutral.gray[2600],
                  width: "1rem",
                  height: "1rem",
                  cursor: "pointer",
                }}
                onClick={() => {
                  rSearch.current.value = "";
                  setSearchTxt("");
                }}
              />
            </SearchField>
            <div className="table-action">
              <Tooltip title="View List">
                <TableViewButton
                  iconColor={showCards}
                  onClick={() => setShowCards(false)}
                  className="MuiButtonBase-root MuiIconButton-root"
                >
                  <span
                    style={{ width: "fit-content" }}
                    className="MuiIconButton-label"
                  >
                    <ViewList className="list-view" />
                  </span>
                </TableViewButton>
              </Tooltip>
              <Tooltip title="View Cards">
                <TableViewButton
                  iconColor={showCards}
                  onClick={() => setShowCards(true)}
                  style={{ borderLeft: "none" }}
                  className="MuiButtonBase-root MuiIconButton-root"
                >
                  <span
                    style={{ width: "fit-content" }}
                    className="MuiIconButton-label"
                  >
                    <ViewCards className="card-view" />
                  </span>
                </TableViewButton>
              </Tooltip>
            </div>
          </div>
        )}
      </CardsWrapper>
      {showSelectedTab(selectedMenu[0])}
      {showDeleteModal()}
      {formTrigger && showCategoryForm()}
    </ContentCardAndFilters>
  );
};

export default AdminCoachesContainer;
